export const compareMethod = {
  COMPARE_METHOD_GT: 'gt', // greater than
  COMPARE_METHOD_GTE: 'gte', // greater than or equal to
};
